import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../../core';

import { RecursoCampanhaFilter } from '../filter';
import { RecursoCampanhaSearchOrderBy } from '../recurso-campanha-search-orderby';
import { RecursoCampanhaSearchHttpService } from '../services';
import { RecursoCampanhaSearch } from '../recurso-campanha-search';
import { isSituacaoInativo, recursoCampanhaSituacaoAtivo } from '../situacao';

@Component({
    selector: 'sgt-recurso-campanha-select',
    templateUrl: './recurso-campanha-select.component.html',
    styleUrls: ['./recurso-campanha-select.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RecursoCampanhaSelectComponent), multi: true },
    ]
})
export class RecursoCampanhaSelectComponent implements OnInit {
    /** ID do recurso de campanha */
    @Input() ngModel: number;
    /** Ao alterar o recurso de campanha*/
    @Output() ngModelChange = new EventEmitter<number>();

    /** Recurso de campanha */
    @Input() recursoCampanha: RecursoCampanhaSearch;
    @Output() recursoCampanhaChange = new EventEmitter<RecursoCampanhaSearch>();

    /** Recursos de campanhas */
    @Input() recursos: RecursoCampanhaSearch[];

    /** Nome do input */
    @Input() name: string;
    /* ID do input */
    @Input() id: string;
    /* Se o valor é obrigatório */
    @Input() required: any;
    /* Se deve desabilitar o input */
    @Input() disabled: boolean;
    /** Se deve setar o focus automaticamente */
    @Input() autofocus = false;
    /** Filtro do tipo do recurso */
    @Input() tipoFilter: number;
    /** Filtro da área do recurso */
    @Input() idAreaFilter: number;
    /** Se deve filtrar somente os recursos de campanhas */
    @Input() somenteAtivos = false;

    @ViewChild('select') select: ElementRef;

    propagateChange: any = () => {};

    constructor(private messageService: MessageService,
                private recursoCampanhaSearchHttpService: RecursoCampanhaSearchHttpService) { }

    ngOnInit() {
        this.search();
    }


    /** Pesquisa os recursos de campanhas */
    private search() {
        this.recursos = [];


        const filter = new RecursoCampanhaFilter();
        // Tipo
        if (this.tipoFilter) {
            filter.tipos = [this.tipoFilter];
        }
        // Área
        if (this.idAreaFilter) {
            filter.idsAreas = [this.idAreaFilter];
        }
        // Somente ativos
        if (this.somenteAtivos) {
            filter.situacoes = [recursoCampanhaSituacaoAtivo.id];
        }

        this.recursoCampanhaSearchHttpService.search(filter, RecursoCampanhaSearchOrderBy.Nome, 'asc', null, null)
            .pipe(
                take(1)
            )
            .subscribe(
                recursos => {
                    this.recursos = recursos;

                    if (this.recursoCampanha) {
                        const indexRecurso = this.recursos?.findIndex(recursoFilter => recursoFilter.id === this.recursoCampanha.id);
                        if (indexRecurso < 0) {
                            this.recursos.unshift(this.recursoCampanha);
                        }
                    }
                },
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar os recursos de campanha', error)
            );
    }

    /** Verifica se o recurso de campanha está inativo */
    isSituacaoInativo(situacao: number): boolean {
        return isSituacaoInativo(situacao);
    }

    /** Ao alterar o recurso de campanha */
    onChange(idRecursoCampanha: number) {
        this.ngModel = idRecursoCampanha;
        this.ngModelChange.emit(this.ngModel);
        this.propagateChange(this.ngModel);

        this.recursoCampanha = this.recursos?.find(recursoFilter => recursoFilter.id === idRecursoCampanha);
        this.recursoCampanhaChange.emit(this.recursoCampanha);
    }

    /** Seta o focus no select */
    setFocus() {
        jQuery(this.select?.nativeElement).trigger('focus');
    }

    writeValue(value: number) {}

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
